import { render } from "./MonthlyExpenses.vue?vue&type=template&id=2e5b787a&scoped=true"
import script from "./MonthlyExpenses.vue?vue&type=script&lang=js"
export * from "./MonthlyExpenses.vue?vue&type=script&lang=js"

import "./MonthlyExpenses.vue?vue&type=style&index=0&id=2e5b787a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5b787a"]])

export default __exports__